import { uniqueId } from 'lodash';
import type { Resolvers } from '../../../../../generated';

export const resolvers: Resolvers = {
  MetadataGroupBy: {
    id: (groupBy) => groupBy.id || uniqueId('groupBy-'),
  },
};
